import head from 'lodash/head';
import {
  FormFieldView,
  FormRenderingMetadata,
  FormsRenderingMetadataResponseDTO,
} from 'dtos';
import {
  FillableFormField,
  FillableFormSession,
} from 'views/EMR/components/FillableForm/types';
import getFieldTypeByField from 'views/EMR/components/FillableForm/utils/getFieldTypeByField';
import isNil from 'lodash/isNil';

function mapField(field: FormFieldView): FillableFormField {
  return {
    ...field,
    type: getFieldTypeByField(field),
    children: field.children?.map(mapField) ?? null,
  };
}

export function serializeSessionData(
  metadata: FormRenderingMetadata,
): FillableFormSession {
  const pdfMedia = head(metadata.formPdf?.list);
  const pdfUrl = pdfMedia?.dataUrl ?? pdfMedia?.url?.value ?? null;

  return {
    formId: metadata.formId,
    title: metadata.title,
    pages: metadata.pages,
    fields: metadata.fields?.map(mapField) ?? [],
    formPdf: metadata.formPdf,
    pdfUrl,
  };
}

export function serializeSessionResponse(
  response: FormsRenderingMetadataResponseDTO,
): FillableFormSession | null {
  const metadata = head(response.renderingData ?? []);

  return isNil(metadata)
    ? null
    : serializeSessionData(metadata);
}
